import React from 'react'
import OralScoreTag from 'components/Patients/Timeline/V2/Tags/OralScoreTag'
import useScanOralScore from 'components/Patients/Timeline/V2/useScanOralScore'
import { Skeleton } from '@material-ui/lab'

const OralHygiene = ({ latestScanTimelineItems, isLoading }) => {
  const latestScan = latestScanTimelineItems[latestScanTimelineItems.length - 1]
  const oralHygieneScore = useScanOralScore({ oralScores: latestScan?.payload?.oralScores })

  return isLoading ? (
    <Skeleton variant="rect" width={70} height={24} style={{ borderRadius: 8 }} />
  ) : oralHygieneScore?.hygieneScore ? (
    <OralScoreTag
      scoreValue={oralHygieneScore.hygieneScore}
      withIcon
      withBackground={false}
      withTitle={false}
      iconSize={24}
      fontSize={16}
    />
  ) : (
    <></>
  )
}

export default OralHygiene
